export const BRANDS_CRUMB_LABEL = 'Brands';
export const BRANDS_PAGE_URL = '/c/brands';

// Static map of refinementKey to event overlay config, used to rewrite the
// breadcrumb trail when one of these events is the active refinement.
export const EVENT_REFINEMENTS = {
  '1z1zdoh': {
    refinementKey: '1z1zdoh',
    slug: 'Black-Friday-Deals',
    label: 'Black Friday',
    url: '/b/Black-Friday-Deals/N-5yc1vZ1z1zdoh'
  },
  '1z1cn1p': {
    refinementKey: '1z1cn1p',
    slug: 'Spring-Black-Friday',
    label: 'Spring Black Friday',
    url: '/b/Spring-Black-Friday/N-5yc1vZ1z1cn1p'
  },
  '1z1zdwm': {
    refinementKey: '1z1zdwm',
    slug: 'Labor-Day-Sale',
    label: 'Labor Day',
    url: '/b/Labor-Day-Sale/N-5yc1vZ1z1zdwm'
  },
  '1z1ze4k': {
    refinementKey: '1z1ze4k',
    slug: 'Fathers-Day-Gifts',
    label: 'Father\'s Day',
    url: '/b/Fathers-Day-Gifts/N-5yc1vZ1z1ze4k'
  },
  '1z1ze6t': {
    refinementKey: '1z1ze6t',
    slug: '4th-of-July-Sale',
    label: '4th of July',
    url: '/b/4th-of-July-Sale/N-5yc1vZ1z1ze6t'
  },
  '1z1ze0l': {
    refinementKey: '1z1ze0l',
    slug: 'Memorial-Day-Sale',
    label: 'Memorial Day',
    url: '/b/Memorial-Day-Sale/N-5yc1vZ1z1ze0l'
  },
  '1z26sjd': {
    refinementKey: '1z26sjd',
    slug: 'Cyber-Monday-Deals',
    label: 'Cyber Monday',
    url: '/b/Cyber-Monday-Deals/N-5yc1vZ1z26sjd'
  },
  '1z21pkd': {
    refinementKey: '1z21pkd',
    slug: 'Mothers-Day-Gifts',
    label: 'Mother\'s Day',
    url: '/b/Mothers-Day-Gifts/N-5yc1vZ1z21pkd'
  }
};
